module.exports = __webpack_public_path__ + "static/media/buildingConstruction2.f2ce5fdb.jpeg";